import React, { useState } from "react";
import { useHistory } from "react-router";
import * as Block from "./index";

type IProps = {
  reloadFilter?: () => void;
};
export default function SecondHeaderIsv(props: IProps) {
  const [show, setShow] = useState(false);

  const history = useHistory();
  const goToFindIsv = () => {
    history.push("/isv/match");
  };
  const goToIsvUnlocked = () => {
    history.push("/isv/isv-unlocked");
  };
  const goToFindMore = () => {
    history.push("/isv/find-more");
  };

  const goFavorite = () => {
    history.push("/isv/favorite-page");
  };

  const urlPath = window.location.href;
  let valueofSubmenu;
  urlPath.indexOf("match") !== -1
    ? (valueofSubmenu = "match")
    : urlPath.indexOf("isv-unlocked") !== -1
    ? (valueofSubmenu = "isv-unlocked")
    : urlPath.indexOf("find-more") !== -1
    ? (valueofSubmenu = "find-more")
    : urlPath?.indexOf("favorite-page") !== -1
    ? (valueofSubmenu = "favorite-page")
    : (valueofSubmenu = "neant");

  return (
    <>
      <div className="secondMenu">
        <div className="container mx-auto">
          <div className="leftItemHeader">
            <h2 className="title">Find ISVs</h2>
            {/* BEGIN TO UNCOMMENT FOR V2*/}
            {/* <Block.Nav
              goFavorite={goFavorite}
              goToFindIsv={goToFindIsv}
              goToFindMore={goToFindMore}
              goToIsvUnlocked={goToIsvUnlocked}
              setShow={setShow}
              valueofSubmenu={valueofSubmenu}
            />
            <Block.ModalBlackListe
              setShow={(p) => setShow(p)}
              show={show}
              reloadFilter={() => props.reloadFilter && props.reloadFilter()}
            /> */}
            {/* END TO UNCOMMENT FOR V2*/}
          </div>

          <div className="rightItemHeader"></div>
        </div>
      </div>
    </>
  );
}
